import { useKeystoneSession } from '@/hooks/useKeystoneSession';

export function SessionBadge() {
  const { authenticated, user, loading, signIn, signOut } =
    useKeystoneSession();

  if (loading) {
    return null;
  }

  if (!authenticated) {
    return (
      <button
        type="button"
        className="session-badge__signin"
        onClick={signIn}
      >
        Sign in with Alterspective
      </button>
    );
  }

  const initials = (user?.displayName || user?.email || '?')
    .split(' ')
    .map((w) => w.charAt(0).toUpperCase())
    .slice(0, 2)
    .join('');

  return (
    <div className="session-badge">
      <span className="session-badge__name" title={user?.email}>
        {user?.displayName || user?.email}
      </span>
      {user?.appRole === 'admin' && (
        <span className="session-badge__role">Admin</span>
      )}
      <span className="session-badge__avatar" aria-hidden="true">
        {initials}
      </span>
      <button
        type="button"
        className="session-badge__signout"
        onClick={signOut}
        aria-label="Sign out"
      >
        Sign out
      </button>
    </div>
  );
}
